import React, { useState } from "react";
import SelectSearch from "react-select-search";
import { getAssetList } from "../services/api";
import PreviewImage from "../assets/previewImage.png";
import { withRouter } from "react-router";

const SearchInputField = (props) => {
  const [param, setParam] = useState(null);

  const onSubmit = (e) => {
    e.preventDefault();
    //get param & find in api when search
    props.history.push(`/asset/${param}?regId=true`);
  };

  // const onInputChange = (e) => {
  //   setParam(e.target.value);
  // };

  function renderAsset(props, option, snapshot, className) {
    const imgStyle = {
      display: "inline",
      borderRadius: "50%",
      verticalAlign: "center",
      marginRight: 10,
    };
    return (
      <button {...props} className={className} type="button">
        {option.photo ? (
          <span>
            <img alt="" style={imgStyle} width="32" height="32" src={`data:image/png;base64, ${option.photo}`} />
            <span>{option.name}</span>
          </span>
        ) : (
          <span>
            <img alt="" style={imgStyle} width="32" height="32" src={PreviewImage} />
            <span>{option.name}</span>
          </span>
        )}
      </button>
    );
  }

  return (
    <form onSubmit={onSubmit} className="px-4">
      {/* <input
        className="searchInputField"
        type="text"
        aria-label="asset barcode"
        placeholder="e.g. 8855459007801"
        required
        onChange={onInputChange}
      /> */}
      <SelectSearch
        options={[]}
        getOptions={(query) => {
          return getAssetList(query);
        }}
        renderOption={renderAsset}
        search
        value={param}
        onChange={setParam}
        placeholder="e.g. 8855459007801"
        emptyMessage="Not found"
      />
      <div className="text-center">
        <button className="mt-6 py-3 px-4 border border-gray-500 rounded-lg" type="submit">
          Find
        </button>
      </div>
    </form>
  );
};

export default withRouter(SearchInputField);
